module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelGroupID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualGroup.group_id.split("::").pop()))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelLinkedOrganization[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualGroup.rightsProviderName))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [(_vm.navIndex.GS.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('h5', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSectionToAddGroupA[_vm.actualLanguage])), _c('i', {
    staticClass: "fa fa-users fa-1x "
  }), _vm._v(_vm._s(_vm.textSectionToAddGroupB[_vm.actualLanguage]))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayConfig === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayConfig) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelConfig[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayConfig) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.subSectionGroupOptionsConfig[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, _vm._l((_vm.actualGroup.group_options), function(groupOption, index) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupOption.value),
        expression: "groupOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupOption.value) ? _vm._i(groupOption.value, null) > -1 : (groupOption.value)
      },
      on: {
        "change": [function($event) {
          var $$a = groupOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupOption, "value", $$c)
          }
        }, _vm.updateGroupOptions]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(groupOption.displayLabel[_vm.actualLanguage]) + "\n                    ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.groupConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewGroupName()
      }
    }
  }, [(_vm.newGroupNameIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.buttonLabelModifyGroupName[_vm.actualLanguage]))])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [(_vm.flagActualGroupDefault == false) ? _c('div', [_c('p', [(_vm.groupConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-block btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteGroup()
      }
    }
  }, [(_vm.groupIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteGroup[_vm.actualLanguage]))])], 1) : _vm._e()])]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingMessage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.groupSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareThisGroup[_vm.actualLanguage]) + _vm._s(_vm.actualGroup.group_name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Group'
      }
    }
  })], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayGroupMembers === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGroupMembers) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-group fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelGroupMembers[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayGroupMembers) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textGroupMembersMessage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnOrganisation[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnEmailEnabled[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnSMSEnabled[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnRemove[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.group_members), function(groupMember, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.organization))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.firstName) + " " + _vm._s(groupMember.LastName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.email))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupMember.memberOptions.emailEnabled),
        expression: "groupMember.memberOptions.emailEnabled"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupMember.memberOptions.emailEnabled) ? _vm._i(groupMember.memberOptions.emailEnabled, null) > -1 : (groupMember.memberOptions.emailEnabled)
      },
      on: {
        "change": [function($event) {
          var $$a = groupMember.memberOptions.emailEnabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupMember.memberOptions, "emailEnabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupMember.memberOptions, "emailEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupMember.memberOptions, "emailEnabled", $$c)
          }
        }, function($event) {
          return _vm.updateGroupMemberOptions(index)
        }]
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupMember.memberOptions.smsEnabled),
        expression: "groupMember.memberOptions.smsEnabled"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupMember.memberOptions.smsEnabled) ? _vm._i(groupMember.memberOptions.smsEnabled, null) > -1 : (groupMember.memberOptions.smsEnabled)
      },
      on: {
        "change": [function($event) {
          var $$a = groupMember.memberOptions.smsEnabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupMember.memberOptions, "smsEnabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupMember.memberOptions, "smsEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupMember.memberOptions, "smsEnabled", $$c)
          }
        }, function($event) {
          return _vm.updateGroupMemberOptions(index)
        }]
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Retirer/Remove"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGroupMember(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addMySelfAsMember()
      }
    }
  }, [(_vm.addMySelfToGroup) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonGroupAddMySelfAsMember[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addOtherProfileAsMember()
      }
    }
  }, [(_vm.addAnotherUserToGroup) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonGroupOtherUserAsMember[_vm.actualLanguage]))])], 1)])])]) : _vm._e()])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8673c67e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ConfigGroup.vue
// module id = 1563
// module chunks = 4